import { Modal } from 'ant-design-vue';

export default {
  props: {
    isPublished: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    guardPublished() {
      if (this.isPublished) {
        Modal.warning({
          title: 'Page is published',
          content: 'Turn off the isPublished toggle first, make your changes, then turn it back on when you\'re done.',
          okText: 'OK',
          centered: true,
          class: 'custom-modal',
          width: 1200,
        });
        return false;
      }
      return true;
    },
  },
};
